import { Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  AppHeaderItemId,
  appHeaderItems,
} from "../../../data/app-header-items";
import { Icons } from "../../../models/assets-files";
import { ImageService } from "../../../services/image.service";
import { StoreState } from "../../../store/store";
import NotificationButton from "../../application/app-header/NotificationButton";
import Image from "../../common/Image";
import useScreen from "../../common/UseScreen";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserService } from "../../../services/user.service";
import { readAllNotifications } from "../../../store/notification.store";

interface AppHeaderProps {
  handleOpenDrawer: VoidFunction;
  handleLogout: VoidFunction;
}

const AppHeader = ({ handleOpenDrawer, handleLogout }: AppHeaderProps) => {
  const user = useSelector((state: StoreState) => state.user.loggedInUser);
  const notifications = useSelector((state: StoreState) => state.notification);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

  const onButtonClick = async (buttonId: AppHeaderItemId) => {
    switch (buttonId) {
      case AppHeaderItemId.NOTIFICATIONS:
        if (!user) {
          return;
        }
        setIsNotificationsOpen(true);
        if (user?.id) {
          dispatch(readAllNotifications());
          await UserService.markNotificationsAsRead(user.id);
        }
        break;
      case AppHeaderItemId.CHAT:
        navigate("/client-requests");
        break;
    }
  };

  const theme = useTheme();
  const { isDesktop } = useScreen();

  const handleButtonClick = (id: AppHeaderItemId) => {
    switch (id) {
      case AppHeaderItemId.LOGOUT:
        handleLogout();
        break;
    }
  };

  return (
    <Box
      sx={{
        zIndex: "10",
        position: "sticky",
        top: "0px",
        height: theme.custom.appHeaderHeight,
        backgroundColor: theme.palette.secondary.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingInline: "20px",
      }}
    >
      {!isDesktop ? (
        <Image
          onClick={handleOpenDrawer}
          sx={{ width: "24px", height: "24px", cursor: "pointer" }}
          src={ImageService.getLocalIconPath(
            Icons.Folders.APP_HEADER,
            Icons.AppHeader.Menu
          )}
        />
      ) : (
        <Box></Box>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {appHeaderItems.map((item) => (
          <Box
            onClick={() => handleButtonClick(item.id)}
            key={item.id}
            sx={{ position: "relative", height: "24px" }}
          >
            {item.id === AppHeaderItemId.NOTIFICATIONS && user && (
              <NotificationButton
                onChange={setIsNotificationsOpen}
                isOpen={isNotificationsOpen}
                notifications={notifications.notifications}
                notificationCount={notifications.unreadCount}
              />
            )}

            <Image
              onClick={() => onButtonClick(item.id)}
              hideSkeleton
              sx={{ width: "24px", height: "24px", cursor: "pointer" }}
              key={item.id}
              src={ImageService.getLocalIconPath(
                Icons.Folders.APP_HEADER,
                item.icon
              )}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AppHeader;
